const _getPublicPath = () => {
  // eslint-disable-next-line camelcase, no-undef
  if (typeof __webpack_public_path__ === 'undefined') return '/';
  // eslint-disable-next-line camelcase, no-undef
  return __webpack_public_path__ || '/';
};

const _normalizeBase = (base) => (base.endsWith('/') ? base : `${base}/`);

export const createGetAssetsLink = (remoteName) => (fileRelativePath) => {
  const base = _normalizeBase(_getPublicPath());
  return `${base}assets/${remoteName}/assets/${fileRelativePath}`;
};
